import React, { PureComponent } from 'react'
import Reflux from 'reflux'
import styled from 'styled-components'

import LoopApi from '/helpers/LoopApi'
// import LoaderInfinity from '../../assets/loaders/infinity.svg'


import { MainStore, MainActions } from '/stores/MainStore'
import Sagas from '../../../helpers/Sagas'
import { AuthStore } from '../../../stores/AuthStore'
import { isJSON } from '../../../helpers'

export default class Knock extends Reflux.Component {
	constructor(props) {
		super(props)

		this.stores = [MainStore, AuthStore]
		this.storeKeys = ['usersKnocking', 'users', 'meetingName', 'jwt']
		this.knockTimeout = null
		this.state = {
			status: null,
		}

		this.startKnock = this.startKnock.bind(this)
		this.handleDeny = this.handleDeny.bind(this)
	}

	componentDidMount() {
		if (window && window.socket && this.props.match.params.meetingName) {
			window.socket.on(this.props.match.params.meetingName, (data) => {
				if(!data.success) {
					if(data.id === this.state.jwt.data._id) {
						this.handleDeny(data.id)
					}
				} else {
					if(data.id === this.state.jwt.data._id) {
						this.setState({ status: 'success' })
						clearTimeout(this.knockTimeout)
						this.knockTimeout = null
						const allowedToJoin = sessionStorage.getItem('roomsAllowed')
						let parsedAllowedToJoin = isJSON(allowedToJoin) ? JSON.parse(allowedToJoin) : {}
						parsedAllowedToJoin[this.props.match.params.meetingName] = true
						parsedAllowedToJoin = JSON.stringify(parsedAllowedToJoin)
						sessionStorage.setItem('roomsAllowed', parsedAllowedToJoin)
						return this.props.JoinedMeeting()
					}
				}
			})}
	}

	componentWillUnmount() {
		clearTimeout(this.knockTimeout)
		this.knockTimeout = null
	}

	startKnock() {
		if (this.state.status === 'knocking' || this.state.status === 'success') {
			return
		}

		this.setState({ status: 'knocking' })
		this.tryKnock()
	}

	handleDeny(id) {
		MainActions.DeniedKnockingUser(id)
		this.setState({ status: 'denied' })
		clearTimeout(this.knockTimeout)
		this.knockTimeout = null
	}

	componentDidUpdate(prevProps, prevState) {
		
		//console.log("prevState: ", prevState.usersKnocking, " this.state: ", this.state.usersKnocking, this.state.users, this.state.meetingName)
	}

	async tryKnock() {
		try {
			const resp = await LoopApi(null, 'TryKnock', {}, [
				['name', this.props.match.params.meetingName],
			])

			if (resp.status === 'success') {
				clearTimeout(this.knockInterval)
				this.knockTimeout = null
				return this.props.JoinedMeeting()
			} else if(resp.status === 'empty') {
				clearTimeout(this.knockInterval)
				this.knockTimeout = null
				return this.setState({ status: 'empty' })
			}

			this.setState({ status: resp.status })
			this.knockTimeout = setTimeout(() => this.tryKnock(), 2000)
		} catch (e) {
			console.error(e)
			this.setState({ status: 'failed' })
		}
	}

	render() {
		if (!this.state.status) {
			return (
				<Container className="topbar rounded inner">
					<Emoj><KnockingIcon /></Emoj>
					<Text>This room is private</Text>
					<SubText>The room has been locked by its owner. Please knock to enter.</SubText>
					<Button className="button primary" onClick={this.startKnock}>
						Knock
					</Button>
				</Container>
			)
		} else if (this.state.status === 'failed') {
			return <Container className="topbar">
				<Title>This room no longer allows knocking</Title>
				</Container>
		} else if (this.state.status === 'empty') {
			return (
				<Container className="topbar rounded inner">
					<Emoj><KnockingIcon /></Emoj>
					<Text>Private Room</Text>
					<SubText>Nobody is in the room</SubText>
					<Button className="button primary" onClick={() => this.startKnock()}>Try again later</Button>
				</Container>
			)
		} else if (this.state.status === 'denied') {
			return (
				<Container className="topbar rounded inner">
					<Emoj><KnockingIcon /></Emoj>
					<Text>Uh oh!</Text>
					<SubText>Someone denied your request. Please try to knock again.</SubText>
					<Button className="button primary" onClick={this.startKnock}>
						Knock
					</Button>
				</Container>
			)
		}

		return (
			<Container className="topbar rounded inner">
				<Emoj><KnockingIcon /></Emoj>
				<Text>Knocking...</Text>
				<SubText>You will be able to join when someone lets you in. Please wait.</SubText>
			</Container>
		)
	}
}

const KnockingIcon = ({ size = 180 }) => {
	return <svg width={size} viewBox="0 0 298 195" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M117 101L95 96" stroke="#2D81FF" stroke-width="3" stroke-linecap="round"/>
		<ellipse cx="148.5" cy="100" rx="6.5" ry="7" fill="#2D81FF"/>
		<ellipse cx="196.5" cy="100" rx="6.5" ry="7" fill="#2D81FF"/>
		<path d="M79.7518 74.5388C79.4003 75.0753 79.242 75.7241 79.3145 76.3691L79.3145 76.3692L84.9635 126.574L85.0812 127.62L86.1046 127.463L89.351 126.966L90.2896 126.822L90.1816 125.862L84.5357 75.6625C84.5356 75.6618 84.5355 75.6611 84.5354 75.6604C84.4757 75.1178 84.255 74.6041 83.8958 74.1926C83.5356 73.7801 83.058 73.4954 82.5294 73.3768C82.0015 73.2583 81.4537 73.3123 80.9593 73.5221C80.4659 73.7315 80.0461 74.0871 79.7518 74.5388ZM79.7518 74.5388C79.7515 74.5393 79.7511 74.5397 79.7508 74.5402L80.5799 75.1001L79.7529 74.5371C79.7525 74.5376 79.7522 74.5382 79.7518 74.5388Z" fill="#F69018" fill-opacity="0.3" stroke="#F69018" stroke-width="2"/>
		<path d="M42.4311 30.756C31.0261 48.168 37.191 67.3939 49.7406 75.9235C53.3577 78.3819 57.9409 80.1777 61.4126 80.5872L59.0918 97.5362C59.0494 97.8473 59.0914 98.1616 59.2131 98.444C59.3347 98.7263 59.5312 98.9656 59.7805 99.1351L70.5296 106.441L64.959 114.946L64.7653 115.277C63.6495 117.247 63.8497 118.199 65.7894 119.607L76.5386 126.913L70.9679 135.418C70.7284 135.783 70.5255 136.01 70.3899 136.164C70.1142 136.472 69.6005 137.049 69.7095 137.926C69.8181 138.827 70.4475 139.218 71.0025 139.563C71.1997 139.688 71.4624 139.851 71.7983 140.079L83.9744 148.355C85.0217 149.065 86.3129 149.309 87.5645 149.031C88.8162 148.753 89.9258 147.977 90.6498 146.873L97.8452 135.888C98.5048 134.877 98.7964 133.665 98.6664 132.476L92.088 73.9784C93.6424 72.3759 95.9182 69.9036 97.1864 67.9673C107.617 52.0437 103.822 30.7412 88.727 20.482C73.6325 10.2227 52.863 14.8295 42.4311 30.756ZM94.4973 66.1437C93.567 67.564 91.6513 69.7772 89.2448 72.218C89.0601 72.4031 88.9187 72.6291 88.8322 72.8777C88.7456 73.1263 88.7161 73.3905 88.7462 73.6491L95.4183 132.964C95.4618 133.346 95.3693 133.736 95.1579 134.062L87.9625 145.047C87.4816 145.781 86.5273 145.993 85.8313 145.52L73.6552 137.244L80.1543 127.322C80.4005 126.946 80.4951 126.489 80.4173 126.052C80.3394 125.615 80.0954 125.233 79.7391 124.991L67.6463 116.772L74.1454 106.85C74.3916 106.474 74.4862 106.017 74.4083 105.58C74.3305 105.143 74.0865 104.761 73.7302 104.519L62.4677 96.8646L64.8922 79.1584C64.9256 78.9154 64.9077 78.6695 64.8396 78.4377C64.7714 78.206 64.6548 77.994 64.4978 77.8163C64.3408 77.6387 64.1471 77.4997 63.9302 77.4089C63.7133 77.3182 63.4783 77.2779 63.2416 77.2908C60.7934 77.4295 55.8783 75.9981 51.5975 73.0886C40.37 65.4576 34.8758 48.2198 45.1183 32.5824C54.5253 18.2208 73.2563 14.064 86.8701 23.3169C100.484 32.5697 103.904 51.7821 94.4973 66.1437Z" fill="#F69018"/>
		<ellipse rx="5.22891" ry="5.00809" transform="matrix(0.520508 -0.853857 0.846392 0.53256 55.9605 48.1318)" fill="#F69018"/>
		<ellipse rx="5.22891" ry="5.00809" transform="matrix(0.520508 -0.853857 0.846392 0.53256 83.3414 44.1347)" fill="#F69018"/>
		<path d="M68 60.1309L76.0202 59" stroke="#F69018" stroke-width="3" stroke-linecap="round"/>
		<path d="M156.816 45.246C156.861 55.7986 156.862 61.7045 156.844 64.8656L138.5 67.4718V67.3373V67.146V66.953V66.7582V66.5618V66.3636V66.1637V65.962V65.7586V65.5534V65.3465V65.1378V64.9273V64.7151V64.5011V64.2852V64.0676V63.8482V63.627V63.404V63.1791V62.9524V62.7239V62.4936V62.2614V62.0273V61.7915V61.5537V61.3141V61.0726V60.8292V60.584V60.3368V60.0878V59.8369V59.584V59.3293V59.0726V58.814V58.5535V58.291V58.0266V57.7603V57.492V57.2217V56.9494V56.6752V56.3991V56.1209V55.8407V55.5586V55.2744V54.9883V54.7001V54.4099V54.1177V53.8235V53.5272V53.2289V52.9285V52.6261V52.3216V52.015V51.7064V51.3957V51.0829V50.7681V50.4511V50.132V49.8109V49.4876V49.1622V48.8346V48.505V48.1732V47.8393V47.5032V47.1649V46.8245V46.482V46.1372V45.7903C138.5 31.3244 143.597 20.6538 151.24 13.4217C158.908 6.16539 169.238 2.27881 179.818 1.60576C201.061 0.254434 222.554 11.7893 225.5 33.8431V64.8949L207.03 63.5763V63.5761V63.5493V63.5223V63.495V63.4674V63.4396V63.4116V63.3833V63.3548V63.326V63.297V63.2677V63.2382V63.2085V63.1785V63.1483V63.1178V63.0871V63.0561V63.0249V62.9935V62.9618V62.9299V62.8977V62.8653V62.8327V62.7998V62.7667V62.7333V62.6997V62.6659V62.6318V62.5975V62.5629V62.5281V62.4931V62.4578V62.4223V62.3865V62.3506V62.3143V62.2779V62.2412V62.2043V62.1671V62.1297V62.0921V62.0542V62.0161V61.9777V61.9392V61.9004V61.8613V61.822V61.7825V61.7428V61.7028V61.6626V61.6222V61.5815V61.5406V61.4995V61.4581V61.4165V61.3747V61.3327V61.2904V61.2479V61.2051V61.1621V61.1189V61.0755V61.0318V60.988V60.9438V60.8995V60.8549V60.8101V60.7651V60.7198V60.6744V60.6286V60.5827V60.5366V60.4902V60.4436V60.3967V60.3497V60.3024V60.2549V60.2071V60.1592V60.111V60.0626V60.014V59.9651V59.916V59.8667V59.8172V59.7675V59.7175V59.6673V59.6169V59.5663V59.5155V59.4644V59.4131V59.3616V59.3099V59.2579V59.2058V59.1534V59.1008V59.048V58.9949V58.9417V58.8882V58.8345V58.7806V58.7264V58.6721V58.6175V58.5628V58.5078V58.4526V58.3971V58.3415V58.2856V58.2296V58.1733V58.1168V58.0601V58.0032V57.946V57.8887V57.8311V57.7733V57.7153V57.6571V57.5987V57.5401V57.4813V57.4222V57.3629V57.3035V57.2438V57.1839V57.1238V57.0635V57.003V56.9422V56.8813V56.8201V56.7588V56.6972V56.6354V56.5735V56.5113V56.4489V56.3863V56.3235V56.2605V56.1972V56.1338V56.0702V56.0063V55.9423V55.878V55.8136V55.7489V55.6841V55.619V55.5537V55.4882V55.4226V55.3567V55.2906V55.2243V55.1578V55.0911V55.0242V54.9571V54.8898V54.8223V54.7546V54.6867V54.6186V54.5503V54.4818V54.4131V54.3442V54.2751V54.2058V54.1364V54.0667V53.9968V53.9267V53.8564V53.7859V53.7152V53.6444V53.5733V53.502V53.4305V53.3589V53.287V53.215V53.1427V53.0703V52.9976V52.9248V52.8518V52.7785V52.7051V52.6315V52.5577V52.4837V52.4095V52.3352V52.2606V52.1858V52.1109V52.0357V51.9604V51.8849V51.8091V51.7332V51.6571V51.5808V51.5044V51.4277V51.3508V51.2738V51.1966V51.1191V51.0415V50.9637V50.8857V50.8076V50.7292V50.6506V50.5719V50.493V50.4139V50.3346V50.2551V50.1754V50.0956V50.0155V49.9353V49.8549V49.7743V49.6936V49.6126V49.5315V49.4501V49.3686V49.2869V49.2051V49.123V49.0408V48.9584V48.8758V48.793V48.71V48.6269V48.5436V48.4601V48.3764V48.2925V48.2085V48.1242V48.0398V47.9553V47.8705V47.7856V47.7005V47.6152V47.5297V47.4441V47.3582V47.2722V47.1861V47.0997V47.0132V46.9265V46.8396V46.7525V46.6653V46.5779V46.4903V46.4026V46.3146V46.2265V46.1383V46.0498V45.9612V45.8724V45.7834V45.6943V45.605V45.5155V45.4258V45.336V45.246V45.1559V45.0655V44.975V44.8843V44.7935V44.7025V44.6113V44.5199V44.4284V44.3367V44.2449V44.1528V44.0606V43.9683V43.8757V43.783V43.6902V43.5971V43.5039V43.4106V43.317V43.2233V43.1295V43.0354V42.9413V42.8469V42.7524V42.6577V42.5628V42.4678V42.3727V42.2773V42.1818V42.0862V41.9903V41.8943V41.7982V41.7019V41.6054V41.5088V41.412V41.315V41.2179V41.1206V41.0232V40.9256V40.8278V40.7299V40.6319V40.5336V40.4352V40.3367V40.238V40.1391V40.0401V39.9409V39.8416V39.7421V39.6424V39.5426V39.4427V39.3426V39.2423V39.1419V39.0413V38.9405V38.8397V38.7386V38.6374V38.5361V38.4346V38.3329V38.2311V38.1291V38.027V37.9247V37.8223V37.7197V37.617V37.5141V37.4111V37.3079V37.2046V37.1011V36.9975V36.8937V36.7898V36.6857V36.5815V36.4771V36.3726V36.2679V36.1631V36.0582V35.9531V35.8478V35.7424V35.6368V35.5311V35.4253V35.3193V35.2132V35.1069V35.0004V34.8939C207.03 29.6005 203.572 25.5099 198.856 22.9184C194.132 20.323 187.925 19.0782 181.773 19.4809C175.615 19.8838 169.365 21.9481 164.638 26.1453C159.873 30.3765 156.779 36.6708 156.816 45.246Z" fill="#F69018" fill-opacity="0.3" stroke="#F69018" stroke-width="3"/>
		<path d="M225.417 168.778C186.459 173.231 163.973 170.963 125.693 162.233C123.529 161.739 121.956 159.87 121.83 157.654L117.239 77.1437C117.101 74.7192 118.725 72.5438 121.092 72.0021C162.211 62.5941 187.187 60.7613 232.141 65.5648M225.417 168.778L232.141 65.5648M225.417 168.778L241.187 162.549C242.977 161.842 244.203 160.17 244.338 158.249L249.798 80.5566C249.923 78.7791 249.093 77.0694 247.618 76.0688L232.141 65.5648" stroke="#2D81FF" stroke-width="3" stroke-linejoin="round"/>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M121.769 157.004L121.83 158.058C121.956 160.273 123.529 162.143 125.693 162.636C163.973 171.366 186.459 173.634 225.417 169.181L241.187 162.953C242.977 162.246 244.203 160.573 244.338 158.653L244.409 157.643C276.675 161.212 298 167.386 298 174.404C298 185.449 245.17 194.404 180 194.404C114.83 194.404 62 185.449 62 174.404C62 166.947 86.0753 160.444 121.769 157.004Z" fill="#2D81FF" fill-opacity="0.3"/>
		<path d="M225 169L231.838 66L247.576 76.4813C249.074 77.4789 249.921 79.2048 249.792 81.0001L244.243 158.469C244.105 160.399 242.867 162.075 241.063 162.774L225 169Z" fill="#2D81FF" fill-opacity="0.3"/>
		<path d="M231.838 66C231.838 66 228.419 117.5 225 169M231.838 66L225 169M231.838 66L247.576 76.4813C249.074 77.4789 249.921 79.2048 249.792 81.0001L244.243 158.469C244.105 160.399 242.867 162.075 241.063 162.774L225 169" stroke="#2D81FF" stroke-width="3" stroke-linejoin="round"/>
		<path d="M172.528 117.046C168.37 117.072 165.021 121.465 165.046 126.86C165.072 132.254 168.463 136.606 172.62 136.581C176.778 136.555 180.128 132.162 180.102 126.767C180.077 121.373 176.686 117.021 172.528 117.046Z" fill="#2D81FF"/>
		<path d="M168.033 133.924C168.046 132.573 169.367 131.622 170.651 132.038L174.906 133.417C175.734 133.685 176.292 134.459 176.287 135.33L176.206 147.89C176.197 149.211 174.933 150.163 173.661 149.805L169.363 148.595C168.495 148.35 167.899 147.555 167.908 146.652L168.033 133.924Z" fill="#2D81FF"/>
		<path d="M237 107.805C248.234 109.668 268.115 116.072 257.762 126.775C247.409 137.479 240.352 146.229 238.118 149.266" stroke="#2D81FF" stroke-width="3" stroke-linecap="round"/>
	</svg>
	
}

const Loader = styled.img`
	height: 54px;
`

const Title = styled.div`
	text-align: center;
	font-weight: 500;
	font-size: 16px;
`

const Container = styled.div`
	padding: 30px;
	box-shadow: ${props => props.theme.shadows.newlight};
	font-size: 16px;
	text-align: center;
	border-radius: 10px;
`

const KnockButton = styled.div`
	cursor: pointer;
	margin-top: 15px;
	box-shadow: ${props => props.theme.shadows.newlight};

	
	&:disabled {
		pointer-events: none;
		opacity: .5;
	}

	&:hover {
		box-shadow: ${props => props.theme.shadows.light};
	}
`



const Button = styled.div`
  margin-top: 30px;
  font-weight: 400;
  cursor: pointer;
`

const Emoj = styled.div`
  font-size: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Text = styled.div`
  text-align: center;
  font-size: 16px;
  margin-top: 24px;
  margin-bottom: 8px;
  font-weight: 500;
`;

const SubText = styled.div`
  opacity: 0.6;
  max-width: 320px;
  font-size: 13px;
  font-weight: 400;
  text-align: center;
`
